// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aR68","content":"styles_content__2VcSJ","tableWrap":"styles_tableWrap__3PWn-"};